import React from 'react';
  
const body = {
    container: {
      backgroundColor: "#282030",
      height: "100vh",
      backgroundImage: "linear-gradient(#5f5668, #282030)"
    }
  }

function Schedules (){
    return (
        <div>
        </div>
    )}
  
export default Schedules;